import { useState } from "react";
import Devider from "../Devider";
import { useAuth } from "../../../../contexts/AuthContext";
import EditNameModal from "./EditNameModal";
import EditEmailModal from "./EditEmailModal";
import EditPasswordModal from "./EditPasswordModal";

const SettingsSection = ({
  title = "name",
  content = "",
  button = "update",
}) => {
  const [open, setOpen] = useState(false);
  const { userInfo } = useAuth();

  return (
    <>
      <Devider color="gray-400" opacity="25" />
      <div className="flex items-center justify-between py-3 text-sm">
        <div className="text-gray-500 font-medium capitalize">{title}</div>
        <div
          className={`text-gray-700 font-medium ${
            title === "name" ? "capitalize" : ""
          }`}
        >
          {content}
        </div>
        <button
          className="text-indigo-600 font-semibold focus:outline-none capitalize"
          onClick={() => setOpen(true)}
        >
          {button}
        </button>
      </div>
      {open && title === "name" && (
        <EditNameModal
          open={open}
          setOpen={setOpen}
          _fname={userInfo?.fname}
          _lname={userInfo?.lname}
        />
      )}
      {open && title === "password" && (
        <EditPasswordModal open={open} setOpen={setOpen} />
      )}

      {open && title === "email" && (
        <EditEmailModal
          open={open}
          setOpen={setOpen}
          _email={userInfo?.email}
        />
      )}
    </>
  );
};

export default SettingsSection;
